import api from "!../../../../../../../../opt/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../../../../../../../opt/node_modules/css-loader/dist/cjs.js??ref--7-1!../../../../../../../../opt/node_modules/vue-loader/dist/stylePostLoader.js!../../../../../../../../opt/node_modules/postcss-loader/src/index.js??ref--7-2!../../../../../../../../opt/node_modules/resolve-url-loader/index.js!../../../../../../../../opt/node_modules/sass-loader/dist/cjs.js??ref--7-4!../../../../../../../../opt/node_modules/vue-loader/dist/index.js??ref--1!./DiscussionPagination.vue?vue&type=style&index=0&id=fb77e608&lang=sass&scoped=true";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};